import type { FaireAdvertiserProfileEntity } from "../../entity_types/advertiserProfile";

// Emily Lex Studio (b_mmdanrh9jf, advertiser 46198651151004914).
// Real numbers from ANALYTICS.ADS.CAMPAIGN_PERIODS (lifetime totals over the 34
// complete months Nov 2023 – Aug 2026). Monthly series + partial Sep 2026 live in
// realBrandData.ts.
//
// The largest program in this fork: ~$429k spend returning ~$8.6M of booked
// sales. POOLED on a $75,000 monthly pool, spending_mode MAXIMUM. NEW campaign
// adc_p9x2ahge9y has run since Nov 2023; REORDER adc_ba4zkex8h8 since Mar 2025.
// CAMPAIGN_PERIODS attributes no acquired-customer sales to reorder, so reorder
// salesDollars is TOTAL_LOCAL_POST_DISCOUNT.
export const advEmilyLexStudio: FaireAdvertiserProfileEntity = {
  token: "adv_emily_lex_studio",
  type: "advertiserProfile",
  archetype: "high-budget-strong-results",
  displayName: "Emily Lex Studio",
  brandToken: "b_mmdanrh9jf",
  audienceType: "NEW_AND_RETURNING",
  globalStatus: "ACTIVE",
  tenureMonths: 35,
  budget: {
    totalBudgetDollars: 75000,
    sharedBudgetDollars: 75000,
    spendingMode: "MAXIMUM",
    nextRenewsAtDate: "2026-10-01",
    nextBillsAtDate: "2026-10-04",
  },
  overview: {
    numCustomersAcquired: 2572,
    numReorderConversions: 4218,
    numTotalConversions: 6790,
    totalAdsSalesDollars: 8619978,
    newCustomerAdsSalesDollars: 6448929,
    reorderAdsSalesDollars: 2171049,
    totalAdsSpendDollars: 428811,
    newCustomerAdsSpendDollars: 229762,
    reorderAdsSpendDollars: 199049,
    newCustomerBestEstimateFirstYearRoas: 21.35,
    reorderRoas: 10.91,
    combinedFirstYearRoas: 16.51,
    numNewCustomerAdsOrders: 15825,
    numReorderAdsOrders: 5030,
  },
  availableCredit: {
    totalRemainingDollars: 0,
  },
  budgetRecommendations: {
    newCustomer: {
      minRecommendedBudgetDollars: 32780,
      maxRecommendedBudgetDollars: 34780,
      isEligibleForIncreaseRec: false,
    },
    reorder: {
      minRecommendedBudgetDollars: 20000,
      maxRecommendedBudgetDollars: 22000,
    },
  },
  campaignTokens: ["camp_els_new", "camp_els_reorder"],
  overviewPerformancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-23T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
